import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 0 1 100%;\n  flex-direction: column;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect, Children, cloneElement } from 'react';
import styled from 'styled-components';
import { CarouselContent } from './CarouselContent';
import { CarouselDots } from './CarouselDots';
var Wrapper = styled.div(_templateObject());

function resolveActiveIndex(activePage) {
  return activePage ? activePage - 1 : 0;
}

function isValidIndex(index, length) {
  return index >= 0 && index < length;
}
/**
 * A simple carousel component
 *
 * @example ./__docs__/Carousel.md
 */


export var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      onChangePage = _ref.onChangePage,
      activePage = _ref.activePage,
      DotsWrapper = _ref.DotsWrapper;

  var _useState = useState(resolveActiveIndex(activePage)),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var childrenArray = Children.toArray(children);
  var items = childrenArray.reduce(function (acc, cur) {
    if (React.isValidElement(cur)) {
      acc.push(cur.props.id);
    }

    return acc;
  }, []);
  var itemCount = items.length;
  useEffect(function () {
    if (typeof activePage !== 'undefined' && activeIndex !== resolveActiveIndex(activePage)) {
      setActiveIndex(resolveActiveIndex(activePage));
    }
  }, [activePage, activeIndex]);
  useEffect(function () {
    if (activePage === undefined && itemCount > 0 && activeIndex >= itemCount) {
      setActiveIndex(0);
    }
  }, [itemCount, activeIndex, activePage]);

  function handlePageChange(newIndex) {
    if (!isValidIndex(newIndex, items.length)) return;

    if (onChangePage) {
      onChangePage(newIndex + 1);
    } else {
      setActiveIndex(newIndex);
    }
  }

  function renderPage(page, index) {
    return React.isValidElement(page) ? cloneElement(page, {
      isActive: index === activeIndex,
      itemsCount: items.length,
      index: index
    }) : null;
  }

  var carouselDots = React.createElement(CarouselDots, {
    activeIndex: activeIndex,
    items: items,
    onPageChange: handlePageChange
  });
  return React.createElement(Wrapper, null, React.createElement(CarouselContent, {
    activeIndex: activeIndex,
    items: items
  }, childrenArray.map(renderPage)), DotsWrapper ? React.createElement(DotsWrapper, {
    activeIndex: activeIndex
  }, carouselDots) : carouselDots);
};